export default "__VITE_ASSET__CwcPjsXp__"